module.exports = __webpack_public_path__ + "img/img34.5c290e18.jpg";